<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M13.4 3.6a1.9 1.9 0 0 1 2.7 2.7L7.4 15 4 16l1-3.4z"/></svg>
</template>
